import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { addTokenParameter as t } from "../../../kernel.js";
import o from "../../../request.js";
import { addProxy as e } from "../../../core/urlUtils.js";
import r from "../support/AttachmentInfo.js";
import { mapParameters as s } from "../../../tasks/operations/urlUtils.js";

function n(t) {
  var o = t.toJSON();
  return o.attachmentTypes && (o.attachmentTypes = o.attachmentTypes.join(",")), o.keywords && (o.keywords = o.keywords.join(",")), o.globalIds && (o.globalIds = o.globalIds.join(",")), o.objectIds && (o.objectIds = o.objectIds.join(",")), o.size && (o.size = o.size.join(",")), o;
}

function a(o, s) {
  var n = {};

  var _iterator = _createForOfIteratorHelper(o),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _a = _step.value;
      var _o = _a.parentObjectId,
          _c = _a.parentGlobalId,
          i = _a.attachmentInfos;

      var _iterator2 = _createForOfIteratorHelper(i),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _a2 = _step2.value;
          var _i = _a2.id,
              m = e(t("".concat(s, "/").concat(_o, "/attachments/").concat(_i))),
              p = r.fromJSON(_a2);
          p.set({
            url: m,
            parentObjectId: _o,
            parentGlobalId: _c
          }), n[_o] ? n[_o].push(p) : n[_o] = [p];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return n;
}

function c(t, e, r) {
  var a = {
    query: s(_objectSpread(_objectSpread({}, t.query), {}, {
      f: "json"
    }, n(e)))
  };
  return r && (a = _objectSpread(_objectSpread(_objectSpread({}, r), a), {}, {
    query: _objectSpread(_objectSpread({}, r.query), a.query)
  })), o(t.path + "/queryAttachments", a);
}

export { c as executeAttachmentQuery, a as processAttachmentQueryResult };